/* @ngInject */
const ariaChipsDecoratorFn = (
	$delegate: ng.IDirective[],
	$timeout: ng.ITimeoutService) => {

	const $ariaChips = $delegate[0];

	// Monkey patch it
	$ariaChips.compile = ((oldCompile) => {
		return function newCompile (tElem: ng.IAugmentedJQuery, tAttrs: ng.IAttributes) {
			// Get the old linkingFn
			const oldLinkingFn = oldCompile.call(this, tElem, tAttrs);

			// Now monkey patch that
			return function newLinkingFn (scope: ng.IScope, elem: ng.IAugmentedJQuery, attr: ng.IAttributes, mdCtrls) {
				oldLinkingFn.call(this, scope, elem, attr, mdCtrls);

				$timeout(() => {
					const chipNameElement = elem[0].querySelector('.md-contact-name') as HTMLElement | null;
					const chipText = chipNameElement?.textContent?.trim();
					const chipContent = elem[0].querySelector('.md-chip-content') as HTMLElement | null;

					if (chipText != null && chipText !== '' && chipContent != null) {
						const chipContentAriaLabel = chipContent.getAttribute('aria-label');
						if (chipContentAriaLabel != null && !chipContentAriaLabel.startsWith(`${chipText}, `)) {
							chipContent.setAttribute('aria-label', `${chipText}, ${chipContentAriaLabel}`);
						}
					}

					const removeButton = elem[0].querySelector('.md-chip-remove') as HTMLButtonElement | null;
					if (chipText == null || chipText === '' || removeButton == null) {
						return;
					}

					const removeButtonAriaLabel = removeButton.getAttribute('aria-label');
					if (removeButtonAriaLabel == null || removeButtonAriaLabel === '') {
						return;
					}

					const baseRemoveLabel = removeButtonAriaLabel.split(' - ')[0].trim();
					const descriptiveRemoveLabel = `${baseRemoveLabel} - ${chipText}`;

					if (removeButtonAriaLabel !== descriptiveRemoveLabel) {
						removeButton.setAttribute('aria-label', descriptiveRemoveLabel);
					}
				}, 0, false);
			};
		};
	})($ariaChips.compile);
	return $delegate;
};

export const ariaChipsDecorator: [string, ng.Injectable<any>] = [
	'mdChipDirective',
	ariaChipsDecoratorFn
];
